export const maxTime = 120
export const max = 3
